import PersonalArea from './personal-area';

export default PersonalArea;
